import React from "react";
import { BaseLayout } from "@components/components";

export const AuctionBase = () => {
    return <BaseLayout full />;
};
